import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { hostVatSupportLink } from '../data/supportLinks';

const TaxDetailsCopy = ({
  classNames = ''
}) => {
  return (
    <div className={`TaxDetailsCopy ${classNames}`}>
      <FormattedMessage
        id="hosting.taxes.tax_details_copy"
        defaultMessage="Adding your tax registration may change how taxes are charged on your bookings. It’s the host’s responsibility to
                        keep all tax details up to date."
      />
      <a className="margin-sm-left underline" href={hostVatSupportLink}
        target="_blank" rel="noopener noreferrer">
        <FormattedMessage
          id='hosting.taxes.learn_more_link'
          defaultMessage=" Learn more"
        />
      </a>
    </div>
  );
};

TaxDetailsCopy.propTypes = {
  classNames: PropTypes.string
};

export default TaxDetailsCopy;
